import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { chapters } from '../data/chapters';
interface ProgressHeaderProps {
  chapterIndex: number;
  chapterProgress: number[];
  canGoBack: boolean;
  onBack: () => void;
}
export function ProgressHeader({
  chapterIndex,
  chapterProgress,
  canGoBack,
  onBack
}: ProgressHeaderProps) {
  const chapter = chapters[chapterIndex];
  return <header className="pointer-events-none absolute inset-x-0 top-0 z-30 px-5 pt-5 md:pt-11" data-id="element-471" data-mp="1mdilcy357e7c">
      <div className="flex h-8 items-center justify-between" data-id="element-472" data-mp="1hexlizrsywjf">
        {canGoBack ? <button type="button" onClick={onBack} aria-label="Go back" className="pointer-events-auto flex h-8 w-8 items-center justify-center rounded-full border border-navy-900/10 bg-white/85 text-navy-700 backdrop-blur-md transition hover:text-navy-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-pulse-teal" data-id="element-473" data-mp="1v62drgsucmjq">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-474" data-mp="1qvgogcblwisd" />
          </button> : <span className="w-8" data-id="element-475" data-mp="1vtrv6e6lud6d" />}
        <p className="rounded-full bg-white/80 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-navy-800 backdrop-blur-md" data-id="element-476" data-mp="1vut8kpb3fbr9">
          Chapter {chapter.number} · {chapter.theme}
        </p>
        <span className="w-8 text-right text-[11px] tabular-nums text-slate-500" data-id="element-477" data-mp="24w9h0ricl3su">
          {chapterIndex + 1}/{chapters.length}
        </span>
      </div>
      <div className="mt-3 grid grid-cols-3 gap-1.5" role="progressbar" aria-label="Story progress" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(chapterProgress.reduce((a, b) => a + b, 0) / chapters.length * 100)} data-id="element-478" data-mp="2eschlsxjwudo">
        {chapters.map((c, i) => <div key={c.id} className="h-[3px] overflow-hidden rounded-full bg-navy-900/10" data-id="element-479" data-mp="2sllnvkq7czrz" data-mpi={i}>
            <motion.div className="h-full rounded-full" style={{
          backgroundColor: c.accent
        }} initial={false} animate={{
          width: `${chapterProgress[i] * 100}%`
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-480" data-mp="2xkf1re9eisso" />
          </div>)}
      </div>
    </header>;
}